// extracted by mini-css-extract-plugin
export default {"main":"CouponBanner_main__JlUOe","content":"CouponBanner_content__XOgG6","dismissButton":"CouponBanner_dismissButton__gZgCy","dismissIcon":"CouponBanner_dismissIcon__0QAJZ"};